import React from 'react';
import { Link } from 'react-router-dom';
export function Careers() {
  return <div className="max-w-4xl mx-auto px-6 pt-32 pb-24" data-id="element-2916">
      <div className="mb-16" data-id="element-2917">
        <h1 className="text-4xl font-bold text-white mb-4 font-title" data-id="element-2918">
          Join Giga
        </h1>
        <p className="text-neutral-400 font-body text-lg max-w-2xl" data-id="element-2919">
          We're building an AI assistant platform that connects to every tool
          your team uses. Help us build the future of work.
        </p>
      </div>

      <div className="space-y-12" data-id="element-2920">
        {/* Principal Engineer */}
        <div className="bg-neutral-900/40 border border-neutral-800 rounded-2xl p-5 md:p-8" data-id="element-2921">
          <div className="flex flex-col md:flex-row md:items-start justify-between gap-6 mb-6" data-id="element-2922">
            <div data-id="element-2923">
              <h2 className="text-2xl font-bold text-white mb-2" data-id="element-2924">
                Principal Engineer
              </h2>
              <div className="flex items-center gap-3 text-sm text-neutral-400" data-id="element-2925">
                <span className="px-2.5 py-1 rounded-md bg-neutral-800/50 border border-neutral-700/50" data-id="element-2926">
                  Engineering
                </span>
                <span data-id="element-2927">•</span>
                <span data-id="element-2928">Remote</span>
                <span data-id="element-2929">•</span>
                <span data-id="element-2930">Full-time</span>
              </div>
            </div>
            <Link to="/contact" className="px-6 py-2.5 bg-white text-[#333333] font-medium rounded-lg hover:bg-neutral-200 transition-colors text-center shrink-0" data-id="element-2931">
              Apply Now
            </Link>
          </div>

          <div className="space-y-6 text-neutral-300 font-body leading-relaxed" data-id="element-2932">
            <p data-id="element-2933">
              We're looking for a hands-on, senior IC to lead backend
              architecture and systems engineering at Giga. Our product is built
              on Linux VMs (not containers), and uses a custom coding harness
              that interacts directly with operating system primitives.
            </p>

            <div data-id="element-2934">
              <h3 className="text-white font-semibold mb-3" data-id="element-2935">What you'll do:</h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-2936">
                <li data-id="element-2937">
                  Architect and maintain our core backend infrastructure built
                  primarily in Ruby.
                </li>
                <li data-id="element-2938">
                  Manage and optimize our Linux VM fleet and sysadmin
                  operations.
                </li>
                <li data-id="element-2939">
                  Build and secure the coding harness that allows our AI agents
                  to execute code safely.
                </li>
                <li data-id="element-2940">
                  Navigate and simplify non-straightforward architectural
                  challenges.
                </li>
              </ul>
            </div>

            <div data-id="element-2941">
              <h3 className="text-white font-semibold mb-3" data-id="element-2942">
                What we're looking for:
              </h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-2943">
                <li data-id="element-2944">
                  Deep expertise in Ruby and backend systems architecture.
                </li>
                <li data-id="element-2945">
                  Strong Linux sysadmin skills and experience managing VM-based
                  infrastructure.
                </li>
                <li data-id="element-2946">
                  Experience with systems programming and OS-level primitives.
                </li>
                <li data-id="element-2947">
                  Comfortable working in complex, non-standard architectures.
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Head of Product */}
        <div className="bg-neutral-900/40 border border-neutral-800 rounded-2xl p-5 md:p-8" data-id="element-2948">
          <div className="flex flex-col md:flex-row md:items-start justify-between gap-6 mb-6" data-id="element-2949">
            <div data-id="element-2950">
              <h2 className="text-2xl font-bold text-white mb-2" data-id="element-2951">
                Head of Product
              </h2>
              <div className="flex items-center gap-3 text-sm text-neutral-400" data-id="element-2952">
                <span className="px-2.5 py-1 rounded-md bg-neutral-800/50 border border-neutral-700/50" data-id="element-2953">
                  Product
                </span>
                <span data-id="element-2954">•</span>
                <span data-id="element-2955">Remote</span>
                <span data-id="element-2956">•</span>
                <span data-id="element-2957">Full-time</span>
              </div>
            </div>
            <Link to="/contact" className="px-6 py-2.5 bg-white text-[#333333] font-medium rounded-lg hover:bg-neutral-200 transition-colors text-center shrink-0" data-id="element-2958">
              Apply Now
            </Link>
          </div>

          <div className="space-y-6 text-neutral-300 font-body leading-relaxed" data-id="element-2959">
            <p data-id="element-2960">
              We're looking for a product leader to help us build and maintain a
              software factory where we go from idea to production in less than
              24 hours. You'll shape the direction of our AI assistant platform
              for teams.
            </p>

            <div data-id="element-2961">
              <h3 className="text-white font-semibold mb-3" data-id="element-2962">What you'll do:</h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-2963">
                <li data-id="element-2964">
                  Lead product strategy and execution for the Giga platform.
                </li>
                <li data-id="element-2965">
                  Drive our rapid iteration cycle (idea to production in
                  &lt;24h).
                </li>
                <li data-id="element-2966">
                  Work closely with engineering to define and prioritize
                  features.
                </li>
                <li data-id="element-2967">
                  Get your hands dirty — this is a builder role, not just
                  high-level strategy.
                </li>
              </ul>
            </div>

            <div data-id="element-2968">
              <h3 className="text-white font-semibold mb-3" data-id="element-2969">
                What we're looking for:
              </h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-2970">
                <li data-id="element-2971">
                  You are already AI-native / AI-pilled and deeply understand
                  the current LLM landscape.
                </li>
                <li data-id="element-2972">
                  Proven experience shipping complex B2B SaaS products rapidly.
                </li>
                <li data-id="element-2973">
                  Willingness to be hands-on in a fast-paced startup
                  environment.
                </li>
                <li data-id="element-2974">Strong product intuition and user empathy.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>;
}